<div class="box{{feel ? ' -feel-'+feel : ''}}" [ngClass]="{'is-inactive': inactive}">
    <div class="box__inner">
        <ng-container *ngIf="header">
            <div class="box__header"
                [ngClass]="{'-border': headerBorder, '-paddings-horizontal': headerHorizontalPaddings, '-paddings-vertical': headerVerticalPaddings}">
                <ng-container *ngTemplateOutlet="header"></ng-container>
            </div>
        </ng-container>

        <div class="box__content"
            [ngClass]="{'-paddings-horizontal': contentHorizontalPaddings, '-paddings-vertical': contentVerticalPaddings}">
            <ng-content></ng-content>
        </div>

        <ng-container *ngIf="footer">
            <div class="box__footer"
                [ngClass]="{'-border': footerBorder, '-shadow': footerShadow, '-paddings-horizontal': footerHorizontalPaddings, '-paddings-vertical': footerVerticalPaddings, '-no-overflow': !footerOverflow, '-top': footerOnTop}">
                <ng-container *ngTemplateOutlet="footer"></ng-container>
            </div>
        </ng-container>
    </div>
</div>